import React, { InputHTMLAttributes, ReactNode, RefAttributes } from 'react'
import clsx from 'clsx'

type Props = InputHTMLAttributes<HTMLInputElement> &
  RefAttributes<HTMLInputElement> & {
    children: ReactNode
  }

const FormSwitch: React.FC<Props> = ({ id, checked, className, children, ...props }) => (
  <label
    htmlFor={id}
    className={clsx(
      'inline-flex rounded text-sm text-gray-800',
      props.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
      className
    )}
  >
    <input
      type="checkbox"
      id={id}
      {...props}
      checked={checked}
      className="peer absolute left-0 top-0 h-4 w-8 opacity-0"
    />
    <div
      className={clsx(
        'relative mr-2.5 mt-px h-6 w-10 rounded-full transition-colors duration-200 ease-in-out',
        'peer-focus:ring-2 peer-focus:ring-gray-200 peer-focus:ring-offset-2',
        checked ? 'bg-primary-600' : 'bg-gray-300'
      )}
    >
      <div
        className={clsx(
          'absolute bottom-0 top-0 my-auto h-5 w-5 rounded-full border-2 border-gray-400 bg-white transition-all duration-200 ease-in-out',
          checked ? 'left-[18px]' : 'left-[2px]'
        )}
      />
    </div>
    <span className={`leading-tight ${props.disabled && 'text-gray-300'}`}>{children}</span>
  </label>
)

export default FormSwitch
